<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="calibre_pb_0"></div>
<p class="calibre3"><span id="pgepubid00015" title="[8]"><a id="Page_8" title="[8]"></a></span></p>
<h2 class="calibre" id="pgepubid00016">CHAPTER I.<br class="calibre16"/>
<span class="cheaderfont">THE SURRENDER OF THE WORLD-THRONE.</span></h2>
<p class="pcalibre drop-capi-m">A HUNDRED years had passed since Natas, the
Master of the Terror, had given into the hands of
Richard Arnold his charge to the future generations
of the Aerians—as the descendants of the
Terrorists who had colonised the mountain-walled
valley of Aeria, in Central Africa, were now
called; since the man, who had planned and accomplished
the greatest revolution in the history of the world, had
given his last blessing to his companions-in-arms and their
children, and had “turned his face to the wall and died.”</p>
<p class="calibre3">It was midday, on the 8th of December 2030, and the
rulers of all the civilised States of the world were gathered
together in St. Paul’s Cathedral to receive, from the hands of a
descendant of Natas in the fourth generation, the restoration of
the right of independent national rule which, on the same spot
a hundred and twenty-five years before, had been taken from
the sovereigns of Europe and vested in the Supreme Council of
the Anglo-Saxon Federation.</p>
<p class="calibre3">The period of tutelage had passed. Under the wise and
firm rule of the Council and the domination of the Anglo-Saxon
race, the Golden Age had seemed to return to the world.
For a hundred and twenty-five years there had been peace on
earth, broken only by the outbreak and speedy suppression of
a few tribal wars among the more savage races of Africa and
Malaysia. Now the descendants of those who had been victors<span id="pgepubid00017" title="[9]"><a id="Page_9" title="[9]"></a></span>
and vanquished in the world-war of 1904, had met to give back
and assume the freedom and the responsibility of national
independence.</p>
<p class="calibre3">The vast cathedral was thronged, as it had been on the
momentous day when Natas had pronounced his judgment on
the last of the Tyrants of Russia, and ended the old order of
things in Europe. But it was filled by a very different assembly
to that which had stood within its walls on the morrow of
Armageddon.</p>
<p class="calibre3">Then the stress and horror of a mighty conflict had set its
stamp on every face. Hate had looked out of eyes in which
the tears were scarcely dry, and hungered fiercely for the
blood of the oppressor. The clash of arms, the stern command,
and the pitiless words of doom had sounded then in ears which
but a few hours before had listened to the roar of artillery and
the thunder of battle. That had been the dawn of the morrow
of strife; this was the zenith of the noon of peace.</p>
<p class="calibre3">Now, in all the vast assembly, no hand held a weapon, no
face was there which showed a sign of sorrow, fear, or anger,
and in no heart, save only two among the thousands, was there
a thought of hate or bitterness.</p>
<p class="calibre3">For three days past the Festival of Deliverance had been
celebrated all over the civilised world, and now, in the centre
of the city which had come to be the capital, not only of the
vast domains of Anglo-Saxondom, but of the whole world, a
solemn act of renunciation was to be performed, upon the
issues of which the fate of all humanity would hang; for the
members of the Supreme Council had come through the skies
from their seat of empire in Aeria to abdicate the world-throne
in obedience to the command of the dead Master, from whom
their ancestors had derived it.</p>
<p class="calibre3">At a table, drawn across the front of the chancel, sat the
President and the twelve men who with him had up to this
hour shared the empire of the human race. Below the steps,
on the floor of the cathedral, sat, in a wide semicircle, the
rulers of the kingdoms and republics of the earth, assembled to
hear the last word of their over-lords, and to receive from them<span id="pgepubid00018" title="[10]"><a id="Page_10" title="[10]"></a></span>
the power and responsibility of maintaining or forfeiting, as the
event should prove, the blessings which had multiplied under
the sovereignty of the Aerians.</p>
<p class="calibre3">The President of the Council was the direct descendant
not only of Alan Tremayne, its first President, but also of
Richard Arnold and Natasha; for their eldest son, born in the
first year of the Peace, had married the only daughter of Tremayne,
and their first-born son had been his father’s father.</p>
<p class="calibre3">Although the average physique of civilised man had
immensely improved under the new order of things, the
Aerians, descendants of the pick of the nations of Europe,
were as far superior to the rest of the assembly as the latter
would have been to the men and women of the nineteenth
century; but even amongst the members of the Council, the
splendid stature and regal dignity of Alan Arnold, the President,
stamped him as a born ruler of men, whose title rested
upon something higher than election or inheritance.</p>
<p class="calibre3">At the last stroke of twelve, the President rose in his place,
and, in the midst of an almost breathless silence, read the
message of Natas to the great congregation. This done, he
laid the parchment down on the table and, beginning from the
outbreak of the world-war, rapidly and lucidly sketched out
the vast and beneficent changes in the government of society
that its issues had made possible.</p>
<p class="calibre3">He traced the marvellous development of the new civilisation,
which, in four generations, had raised men from a state
of half-barbarous strife and brutality to one of universal peace
and prosperity; from inhuman and unsparing competition to
friendly co-operation in public, and generous rivalry in private
concerns; from horrible contrasts of wealth and misery to a
social state in which the removal of all unnatural disabilities
in the race of life had made them impossible.</p>
<p class="calibre3">He showed how, in the evil times which, as all men hoped,
had been left behind for ever, the strong and the unscrupulous
ruthlessly oppressed the weak and swindled the honest and the
straightforward. Now dishonesty was dishonourable in fact as
well as in name; the game of life was played fairly, and its<span id="pgepubid00019" title="[11]"><a id="Page_11" title="[11]"></a></span>
prizes fell to all who could win them, by native genius or
earnest endeavour.</p>
<p class="calibre3">There were no inequalities, save those which Nature herself
had imposed upon all men from the beginning of time. There
were no tyrants and no slaves. That which a man’s labour of
hand or brain had won was his, and no man might take toll of
it. All useful work was held in honour, and there was no
other road to fame or fortune save that of profitable service to
humanity.</p>
<p class="calibre3">“This,” said the President in conclusion, “is the splendid
heritage that we of the Supreme Council, which is now to cease
to exist as such, have received from our forefathers, who won
it for us and for you on the field of the world’s Armageddon.
We have preserved their traditions intact, and obeyed their
commands to the letter; and now the hour has come for us,
in obedience to the last of those commands, to resign our
authority and to hand over that heritage to you, the rulers of
the civilised world, to hold in trust for the peoples over whom
you have been appointed to reign.</p>
<p class="calibre3">“When I have done speaking I shall no longer be President
of the Senate, which for a hundred and twenty-five years has
ruled the world from pole to pole and east to west. You and
your parliaments are henceforth free to rule as you will. We
shall take no further part in the control of human affairs
outside our domain, saving only in one concern.</p>
<p class="calibre3">“In the days when our command was established, the only
possible basis of all rule was force, and our supremacy was
based on the force that we could bring to bear upon those who
might have ventured to oppose us or revolted against our rule.
We commanded, and we will still command, the air, and I
should not be doing my duty, either to my own people or to
you, if I did not tell you that the Aerians, not as the world-rulers
that they have been, but as the citizens of an independent
State, mean to keep that power in their own hands at
all costs.</p>
<p class="calibre3">“The empire of earth and sea, saving only the valley of
Aeria, is yours to do with as you will. The empire of the air<span id="pgepubid00020" title="[12]"><a id="Page_12" title="[12]"></a></span>
is ours,—the heritage that we have received from the genius
of that ancestor of mine who first conquered it.</p>
<p class="calibre3">“That we have not used it in the past to oppress you is the
most perfect guarantee that we shall not do so in the future,
but let all the nations of the earth clearly understand, that we
shall accept any attempt to dispute it with us as a declaration
of war upon us, and that those who make that attempt will
either have to exterminate us or be exterminated themselves.
This is not a threat, but a solemn warning; and the responsibility
of once more bringing the curse of war and all its
attendant desolation upon the earth, will lie heavily upon those
who neglect it.</p>
<p class="calibre3">“A few more needful words and I have done. The message
of the Master, which I have read to you, contains a prophecy,
as to the fulfilment of which neither I nor any man here may
speak with certainty. It may be that he, with clearer eyes
than ours, saw some tremendous catastrophe impending over
the world, a catastrophe which no human means could avert,
and beneath which human strength and genius could only bow
with resignation.</p>
<p class="calibre3">“By what spirit he was inspired when he uttered the
prophecy, it is not for us to say. But before you put it aside
as an old man’s dream, let me ask you to remember, that he
who uttered it was a man who was able to plan the destruction
of one civilisation, and to prepare the way for another and a
better.</p>
<p class="calibre3">“Such a man, standing midway between the twin mysteries
of life and death, might well see that which is hidden from our
grosser sight. But whether the prophecy itself shall prove
true or false, it shall be well for you and for your children’s
children if you and they shall receive the lesson that it teaches
as true.</p>
<p class="calibre3">“If, in the days that are to come, the world shall be overwhelmed
with a desolation that none shall escape, will it not
be better that the end shall come and find men doing good
rather than evil? As you now set the peoples whom you
govern in the right or the wrong path, so shall they walk.</p>
<p class="calibre3"><span id="pgepubid00021" title="[13]"><a id="Page_13" title="[13]"></a></span></p>
<p class="calibre3">“This is the lesson of all the generations that have gone
before us, and it shall also be true of those that are to come
after us. As the seed is, so is the harvest; therefore see to it
that you, who are now the free rulers of the nations, so discharge
the awful trust and responsibility which is thus laid
upon you, that your children’s children shall not, perhaps in
the hour of Humanity’s last agony, rise up and curse your
memory rather than bless it. I have spoken!”</p>
<div class="figcenter3">
<img alt="" class="calibre13" id="id-3806593183361929602" src="Images/img0003.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0006.vue?3b8c19c1